// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"541ec3c4","320":"1d8acf23","322":"71f60cbb","502":"d59a8ab3","726":"ee4f0a0a","917":"32823d55"}[chunkId] + ".chunk.js";
};